<template>
  <v-app dark class="tech-app-wrapper">
    <div class="circuit-overlay"></div>
    <div class="scanlines"></div>

    <vue-headful :title="title" />

    <section class="content-relative fill-height d-flex align-center">
      <v-container>
        
        <v-row justify="center" class="mb-12">
          <v-col cols="12" class="text-center">
            <v-icon size="70" color="cyan accent-3" class="mb-4 glow-icon">mdi-satellite-uplink</v-icon>
            <h1 class="text-h3 font-weight-black white--text text-uppercase neon-text tracking-widest">
              Frecuencia de Contacto
            </h1>
            <div class="subtitle-text cyan--text text--lighten-3 mono-font mt-2">
              > Estableciendo enlace seguro con HQ..._
            </div>
          </v-col>
        </v-row>

        <v-row align="stretch" justify="center">
          
          <v-col cols="12" lg="5" md="6" class="mb-6">
            <v-card class="tech-card fill-height elevation-10 overflow-hidden d-flex flex-column">
              <div class="card-header-neon pa-4 border-bottom-neon d-flex justify-space-between align-center">
                <span class="mono-font font-weight-bold cyan--text">>> COMMS_MODULE_V1.0</span>
                <div class="d-flex">
                  <div class="dot red mr-2"></div>
                  <div class="dot yellow mr-2"></div>
                  <div class="dot green"></div>
                </div>
              </div>

              <v-card-text class="pa-8 flex-grow-1 d-flex flex-column justify-center">
                
                <div v-for="(item, index) in datosOficina" :key="index" class="mb-8">
                  <div class="d-flex align-start info-panel pa-4 rounded border-blue-glow">
                    <v-avatar size="50" class="neon-border-circle mr-4" color="rgba(0, 255, 255, 0.1)">
                      <v-icon color="cyan accent-3">
                        {{ index === 0 ? 'mdi-phone-classic' : 'mdi-email-lock' }}
                      </v-icon>
                    </v-avatar>
                    
                    <div>
                      <div class="overline grey--text text--lighten-1 mb-1 mono-font">
                        {{ item.titulo }}
                      </div>
                      <div class="text-h5 white--text font-weight-bold text-shadow-blue text-wrap">
                        {{ item.info }}
                      </div>
                      
                      <div class="mt-2">
                        <v-chip 
                          small 
                          outlined 
                          color="cyan" 
                          class="mono-font cursor-pointer hover-glow"
                          :href="index === 0 ? `tel:${item.info}` : `mailto:${item.info}`"
                        >
                          <v-icon left x-small>mdi-connection</v-icon> 
                          {{ index === 0 ? 'LLAMAR' : 'ENVIAR DATA' }}
                        </v-chip>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="terminal-status mt-auto pt-4 border-top-dashed">
                  <span class="blink-text green--text mono-font text-caption">● EN LÍNEA: SISTEMAS NOMINALES</span>
                </div>

              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" lg="7" md="6">
            <v-card class="tech-card fill-height elevation-10 overflow-hidden">
              <div class="card-header-neon pa-4 border-bottom-neon d-flex align-center">
                <v-icon left color="cyan accent-3" small>mdi-crosshairs-gps</v-icon>
                <span class="mono-font font-weight-bold cyan--text">>> GEO_LOCATION_TARGET</span>
              </div>

              <div class="map-wrapper relative">
                <div class="hud-corner top-left"></div>
                <div class="hud-corner top-right"></div>
                <div class="hud-corner bottom-left"></div>
                <div class="hud-corner bottom-right"></div>
                
                <div class="map-grid-overlay pointer-events-none"></div>

                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3900.7168079529893!2d-86.26821007790747!3d12.131518580648443!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f7155e45947c2c5%3A0x8eaf963e036e7444!2sNational%20University%20of%20Engineering%20(UNI)!5e0!3m2!1sen!2sni!4v1605127943955!5m2!1sen!2sni"
                  width="100%"
                  height="100%"
                  frameborder="0"
                  style="border:0; min-height: 400px; filter: grayscale(100%) invert(90%) contrast(1.2);"
                  allowfullscreen=""
                  aria-hidden="false"
                  tabindex="0"
                  class="tech-iframe"
                ></iframe>
              </div>
              
              <div class="pa-2 grey darken-4 d-flex justify-space-between caption mono-font grey--text">
                <span>LAT: 12.1328° N</span>
                <span>LNG: 86.2504° W</span>
                <span>SECURE_ZONE</span>
              </div>
            </v-card>
          </v-col>

        </v-row>
      </v-container>
    </section>
  </v-app>
</template>

<script>
import vueHeadful from 'vue-headful';

export default {
  components: {
    vueHeadful
  },
  data: () => ({
    title: 'Contáctenos',
    datosOficina: [
      {
        titulo: 'ENLACE DE VOZ (COBRANZA)',
        info: '(505) 2278-3141',
      },
      {
        titulo: 'NODO DE CORREO ELECTRÓNICO',
        info: 'info@nic.uni.edu.ni',
      },
    ],
    // Variables del formulario (Mantenidas por si decides descomentarlo luego)
    nombre: '',
    apellido: '',
    email: '',
    mensaje: '',
    valid: false,
    submitted: false
  }),
  methods: {
    submit() {
      this.submitted = true
    }
  }
}
</script>

<style scoped>
/* --- ESTÉTICA CYBERPUNK / HIGH-TECH --- */

/* Importar Fuentes */
@import url('https://fonts.googleapis.com/css2?family=Fira+Code:wght@400;600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700;900&display=swap');

.tech-app-wrapper {
  background-color: #050a14 !important; /* Negro azulado profundo */
  font-family: 'Montserrat', sans-serif;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}

.mono-font { font-family: 'Fira Code', monospace !important; }
.tracking-widest { letter-spacing: 2px; }

/* Fondos y Capas */
.circuit-overlay {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  background-image: 
    radial-gradient(circle at 80% 20%, rgba(0, 255, 255, 0.05) 0%, transparent 40%),
    linear-gradient(0deg, rgba(0,0,0,0.2) 50%, transparent 50%);
  background-size: cover, 4px 4px;
  z-index: 0;
}

.scanlines {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  background: linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,0) 50%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.1));
  background-size: 100% 4px;
  pointer-events: none;
  z-index: 1;
}

.content-relative { position: relative; z-index: 2; }

/* Texto Neón */
.neon-text { text-shadow: 0 0 10px rgba(0, 229, 255, 0.6), 0 0 20px rgba(0, 229, 255, 0.3); }
.text-shadow-blue { text-shadow: 0 0 10px rgba(41, 121, 255, 0.6); }
.glow-icon { filter: drop-shadow(0 0 8px cyan); }

/* Tarjetas Tech */
.tech-card {
  background: rgba(13, 25, 45, 0.85) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 255, 255, 0.2) !important;
}

.card-header-neon {
  background: rgba(0, 229, 255, 0.05);
}

.border-bottom-neon { border-bottom: 1px solid rgba(0, 255, 255, 0.3) !important; }
.border-top-dashed { border-top: 1px dashed rgba(0, 255, 255, 0.2) !important; }

/* Paneles de Información (Sustituto de Tabla) */
.info-panel {
  background: rgba(0, 0, 0, 0.4);
  transition: all 0.3s ease;
}
.info-panel:hover {
  background: rgba(0, 229, 255, 0.05);
  transform: translateX(5px);
}
.border-blue-glow {
  border-left: 3px solid cyan;
  box-shadow: inset 10px 0 20px -10px rgba(0, 255, 255, 0.1);
}

.neon-border-circle {
  border: 2px solid cyan;
  box-shadow: 0 0 10px rgba(0, 255, 255, 0.2);
}

/* Dots de Ventana */
.dot { width: 10px; height: 10px; border-radius: 50%; opacity: 0.7; }
.red { background: #ff5f56; }
.yellow { background: #ffbd2e; }
.green { background: #27c93f; }

/* Mapa HUD */
.map-wrapper {
  position: relative;
  height: 100%;
  min-height: 400px;
  overflow: hidden;
}

.tech-iframe {
  /* Filtro para hacer el mapa oscuro/tech */
  filter: grayscale(100%) invert(90%) hue-rotate(180deg) contrast(1.2) !important;
}

.map-grid-overlay {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  background-image: linear-gradient(rgba(0, 255, 255, 0.1) 1px, transparent 1px),
  linear-gradient(90deg, rgba(0, 255, 255, 0.1) 1px, transparent 1px);
  background-size: 50px 50px;
  z-index: 2;
  pointer-events: none;
}

/* Esquinas HUD para el mapa */
.hud-corner {
  position: absolute; width: 20px; height: 20px;
  border-color: cyan; border-style: solid;
  z-index: 3;
}
.top-left { top: 10px; left: 10px; border-width: 3px 0 0 3px; }
.top-right { top: 10px; right: 10px; border-width: 3px 3px 0 0; }
.bottom-left { bottom: 10px; left: 10px; border-width: 0 0 3px 3px; }
.bottom-right { bottom: 10px; right: 10px; border-width: 0 3px 3px 0; }

/* Animaciones y Utilidades */
.blink-text { animation: blink 2s infinite; }
@keyframes blink { 0% { opacity: 1; } 50% { opacity: 0.4; } 100% { opacity: 1; } }

.hover-glow:hover {
  box-shadow: 0 0 10px cyan;
}
.cursor-pointer { cursor: pointer; }
.pointer-events-none { pointer-events: none; }

/* Ajustes Responsive */
@media (max-width: 960px) {
  .info-panel { flex-direction: column; align-items: center; text-align: center; }
  .border-blue-glow { border-left: none; border-top: 3px solid cyan; }
  .neon-border-circle { margin-right: 0 !important; margin-bottom: 10px; }
}
</style>